import React from 'react';
import { Tag, Text } from '@amzn/storm-ui';
import { getBreadcrumbLabel } from './breadcrumbsHelper';

export const TextBreadcrumb = ({ breadcrumb }) => {
  return (
    <Text inline>
      {getBreadcrumbLabel(breadcrumb)}
      {breadcrumb.objectSuffix && (
        <Tag variant="beta" label={breadcrumb.objectSuffix} />
      )}
    </Text>
  );
};
